module.exports = __webpack_public_path__ + "img/playStore-en.fbc75b9f.png";